
import React, { useState, useEffect, useContext } from "react";
import useForm from "../../../services/UseForm";
import validate from '../../../validations/admin/product/UploadMenuIconSchema';
import {storage} from '../../../firebase';
import axios from "axios";
import { API } from "../../../services/api";
import '../../../css/UploadImg.css';
import ProgressBar from "../../../components/ProgressBar";
import { ProgressBarContext } from "../../../App";
import "bootstrap/dist/css/bootstrap.min.css";
import {UserContext } from "../../../App";

axios.defaults.baseURL = API;

function UploadIconMenu() {
    const {userID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
    const [image , setImage] = useState(null);
    const [MenuID, setMenuID] = useState(null);
    const {setShowProgressBar, setProgress} = useContext(ProgressBarContext);
    const [imagePreview, setImagePreview] = useState(null);
    const [MenuList, setMenuList] = useState([]);

    const handleSelectProductType = (e) => {
        const { value } = e.target;
        const results = MenuList.filter((data) => {
            return data.ProductType.toLowerCase() === value.toLowerCase()
        });
        if (results.length > 0){
            setMenuID(results[0].MenuID);
            handleChange("MenuID", results[0].MenuID);
        } else {
            handleChange("MenuID","");
        }
    };

     async function getMenu() {
        axios
        .get("/getmenu")
        .then((response) => {
            let Data = response?.data;
            setMenuList(Data);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setImage(event.target.files[0]);
            handleChange("Image", event.target.files[0].name);
            const objectUrl = URL.createObjectURL(file);
            setImagePreview(objectUrl);
        } else {
            setImage(null);
            handleChange("Image", "");
        }
    };

    const UpdateProductImgUrl = async () => {
        setShowProgressBar(true);
        setProgress(30); 
        try {
            let token = localStorage.getItem("token");
            const formData = new FormData();
                  formData.append('image', image);

        setProgress(70);
        await axios.put(`/UploadMenuIcon/${MenuID}`, formData, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
           let temOrder = response?.data;
            getImageProduct();
        }).catch((err) => {
            console.log(err);
        });
        
        setProgress(100);
        } catch (error) {
            console.error('API Error:', error);
        } finally {
            setShowProgressBar(false);
            setProgress(0);
        }
    };


    async function getImageProduct () {
        if(MenuID){
            let token = localStorage.getItem("token");

             await axios.put(`/getMenuIconByMenuID/${MenuID}`, { responseType: 'blob' }) // 1. Force blob response
            .then((response) => {
                let temOrder = response?.data;
                setImagePreview(temOrder.url);
            })
            .catch((error) => console.error('Error fetching image:', error)); 
        } 
    }



    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(UpdateProductImgUrl, validate);

    const handleclickBack = () => {
        setShowForm(false);
        setshowSubmenu(true);
    };
  
  useEffect(() => {
    getMenu();
  }, []);

  return (
    
    <div className="uploadimgform">
      <ProgressBar bgcolor="orange" progress='0'  height={30} />
          <div className="MainUploadContent">
            <div className="Header">
                <div className="title">
                    <span>Upload Product Image</span>
                </div>
            </div>
                <form onSubmit={handleSubmit} noValidate>
                    <div className="bodyheader">
                        <div className="barcode">
                            <div className="txtSearchProduct">
                                <div className="form-group">
                                    <label>ເມນູ: </label>
                                        <select name="MenuID" onChange={(e) => handleSelectProductType(e)}
                                            className={`input form-control ${errors.MenuID && 'is-invalid'}`}>
                                            <option
                                                key={""}
                                                value={""}
                                            >
                                                {'ເລືອກປະເພດສິນຄ້າ'}
                                            </option>
                                            {   MenuList && MenuList.map(item => (
                                                <option
                                                    key={item.MenuID}
                                                    value={item.ProductType}
                                                >
                                                    {item.ProductType}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                            </div>
                            <div className="btnContent">
                                <button type="submit" className="btn btn-primary">Upload</button>
                                <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
                            </div>  
                        </div>
                        <div className="upload-img">
                            <input type="file" accept="image/*" className={`input form-control ${errors.Image && 'is-invalid'}`} onChange={(event)=> handleImageChange(event)}/>
                            <div className="product-img">
                               {imagePreview && (
                                    <img 
                                        src={imagePreview} 
                                        alt="Selected Preview" 
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </form> 
        </div>
    </div>
  );
};

export default UploadIconMenu;
